// extracted by mini-css-extract-plugin
module.exports = {"list-content":"List_list-content__u4eH7","list-content-intro":"List_list-content-intro__46mUX"};